import { useEffect, useState } from 'react'

import { SubmitRiddleResponse as BLSubmitRiddleResponse } from './../../../utilities/BL/Zones'


const Riddle = ({ riddle }) => {
    const [selectedOption, setSelectedOption] = useState(null)
    const [isItemVisible, setIsItemVisible] = useState(false)


    // Reiniciar todo al cambiar de pregunta
    useEffect(() => {
        setSelectedOption(null)

        if (riddle.isItemVisible) {
            setIsItemVisible(true)
                        
            const tmpData = sessionStorage.getItem('eudnrlanrbaewq')

            if (!tmpData) {
                return
            }

            const data = JSON.parse(tmpData)
            if (!data) {
                return
            }

            const id = data?.id
            if (!id) {
                return
            }

            const options = riddle?.options 
            if (!options) {
                return
            }

            const option = options.find(option => option.id === id)

            setSelectedOption(option)
        } else {
            setIsItemVisible(false)

            // Obtener el que se guardó anteriormente para mostrar que ya seleccionó.
            // En caso de que no haya seleccionado, mostrar mensaje de que no seleccionó alguno
            const tmpData = sessionStorage.getItem('eudnrlanrbaewq')

            if (tmpData) {
                const data = JSON.parse(tmpData)
                if (!data) {
                    return
                }

                const id = data?.id
                if (!id) {
                    return
                }

                const options = riddle?.options 
                if (!options) {
                    return
                }
    
                const option = options.find(option => option.id === id)
    
                setSelectedOption(option)
            } else {
                // Borrar el elemento guardado en sessionStorage
                sessionStorage.removeItem('eudnrlanrbaewq')
                return
            }
        }
    }, [riddle])

    const handleOptionClick = async (option) => {
        if (selectedOption !== null) return // ya respondió

        setSelectedOption(option)
        sessionStorage.setItem('eudnrlanrbaewq', JSON.stringify(option))

        if (option.isCorrect) {
            try {
                const response = await BLSubmitRiddleResponse(riddle.questionId)
                
                if (!response.success) {
                    console.warn('❌ Error al enviar respuesta:', response.message)
                }
            } catch (err) {
                console.error('❌ Error inesperado:', err)
            }
        }
    }

    if (!riddle || riddle.options === undefined || riddle.options.length === 0) {
        return <p className="Riddle__Title">Cargando opciones...</p>
    }


    return (
        <div className="Riddle">
            {/* Mostrar opciones SOLO si aún no ha respondido */}
            {isItemVisible === false && (
                selectedOption === null ? (
                    <>
                        <p className="Riddle__Title">Selecciona una opción</p>
    

                        {/* Cuando trae imágenes
                        <div className="Riddle__Options">
                            {riddle.options.map((option, index) => (
                                <button key={index} className="Riddle__Options__Buttons Btn__Adsl--RedOutline" onClick={() => handleOptionClick(option)}>
                                    {option.image && (
                                        option.image !== '' && (
                                            <img src={option.image} className='Riddle__Options__Buttons__Image' />
                                        )
                                    )}
                                    <span className='Riddle__Options__Buttons__Text'>{option.text}</span>
                                </button>
                            ))}
                        </div>
                        */}

                        <div className="Riddle__Tiles">
                            {riddle.options.map((option, index) => (
                                <button key={index} className="Riddle__Tiles__Buttons Btn__Adsl--RedOutline" onClick={() => handleOptionClick(option)}>
                                    <span className='Riddle__Tiles__Buttons__Text'>{option.text}</span>
                                </button>
                            ))}
                        </div>
                    </>
                ) : (
                    <div>
                        <p className="Riddle__Title">Tú elegiste...</p>
                        {selectedOption.image && (
                            selectedOption.image !== '' && (
                                <img src={selectedOption.image} className='Riddle__Image' />
                            )
                        )}
                        <p className="Riddle__Title">{selectedOption.text}</p>
                    </div>
                )
            )}

            {/* Mostrar respuesta seleccionada una vez respondido */}
            {isItemVisible && (
                selectedOption === null ? (
                    <div>
                        <p className="Riddle__Title">¡Ups!</p>
                        <p className="Riddle__Title">No has elegido una opción</p>
                    </div>
                ) : (
                    <div>
                        <p className="Riddle__Title">Tú elegiste...</p>
                        {selectedOption.image && (
                            selectedOption.image !== '' && (
                                <img src={selectedOption.image} className='Riddle__Image' />
                            )
                        )}
                        <p className="Riddle__Title">{selectedOption.text}</p>
                    </div>
                )
            )}
        </div>
    )
}

export { Riddle };